import { IMDSButtonProps, MDSButton, MDSButtonVariant } from "@/mds/components/buttons";
import styled from "@emotion/styled";

interface MDSSidebarButtonProps extends IMDSButtonProps {}

export const MDSSidebarButton = ({ children, ...props }: MDSSidebarButtonProps) => {
  return (
    <StyledButton {...props} variant={MDSButtonVariant.Chrome}>
      {children}
    </StyledButton>
  );
};

const StyledButton = styled(MDSButton)`
  justify-content: flex-start;
  box-shadow: none;
`;
